import { Text, Anchor } from 'summon-ui/mantine'

const ZKSYNC_BRIDGE_URL = 'https://portal.zksync.io/bridge/'

const BridgeLink = () => {
  return (
    <Text size='xs'>
      Need zkETH for gas?{' '}
      <Anchor href={ZKSYNC_BRIDGE_URL} target='_blank' underline='always'>
        Bridge here
      </Anchor>
    </Text>
  )
}

export default BridgeLink
